// extracted by mini-css-extract-plugin
export default {"modalOverlay":"wD-z","modalContent":"xD-z","header":"yD-z","close":"zD-z"};